<div class="card-header border-b-2 border-[var(--bg-color)] bg-[var(--bg-color)] px-5 py-2.5 text-[17px] font-semibold text-[var(--text-color)]
     [&.active]:bg-[var(--warning-bg-color)]
     [.admin_&]:flex [.admin_&]:flex-wrap [.admin_&]:items-center [.admin_&]:justify-between [.admin_&]:gap-2.5"
     [class.active]="active()"
     [style.background-color]="bgColor()">
  <ng-content/>
</div>
